<script setup>
import { useI18n } from 'vue-i18n';
import LaisDrawer from 'dashboard/components-next/LaisDrawer.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  show: { type: Boolean, default: false },
  createdByOptions: { type: Array, default: () => [] },
  statusOptions: { type: Array, default: () => [] },
  waitingOptions: { type: Array, default: () => [] },
  slaFilterOptions: { type: Array, default: () => [] },
  assigneeOptions: { type: Array, default: () => [] },
  canViewAccountTickets: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'clear', 'submit']);

const filters = defineModel({ type: Object, required: true });

const { t } = useI18n();
</script>

<template>
  <LaisDrawer
    :show="show"
    side="bottom"
    :title="t('SUPPORT_TICKETS.FILTERS.TITLE')"
    @close="emit('close')"
  >
    <template #body>
      <form class="grid gap-3" @submit.prevent="emit('submit')">
        <LaisField :label="t('SUPPORT_TICKETS.FILTERS.SEARCH')">
          <input
            v-model.trim="filters.q"
            type="search"
            class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
            :placeholder="t('SUPPORT_TICKETS.FILTERS.SEARCH_PLACEHOLDER')"
          />
        </LaisField>
        <LaisField :label="t('SUPPORT_TICKETS.FILTERS.CREATOR')">
          <select
            v-model="filters.created_by"
            class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
          >
            <option
              v-for="item in createdByOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </LaisField>
        <LaisField :label="t('SUPPORT_TICKETS.FILTERS.STATUS')">
          <select
            v-model="filters.status"
            class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
          >
            <option
              v-for="item in statusOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </LaisField>
        <LaisField :label="t('SUPPORT_TICKETS.FILTERS.WAITING')">
          <select
            v-model="filters.waiting_on"
            class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
          >
            <option
              v-for="item in waitingOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </LaisField>
        <div v-if="canViewAccountTickets" class="grid gap-3">
          <LaisField :label="t('SUPPORT_TICKETS.FILTERS.SLA')">
            <select
              v-model="filters.sla_status"
              class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
            >
              <option
                v-for="item in slaFilterOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </LaisField>
          <LaisField :label="t('SUPPORT_TICKETS.FILTERS.ASSIGNEE')">
            <select
              v-model="filters.assignee_id"
              class="h-10 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text outline-none focus:border-lais-primary"
            >
              <option
                v-for="item in assigneeOptions"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
          </LaisField>
        </div>
      </form>
    </template>
    <template #footer>
      <div class="grid grid-cols-2 gap-2">
        <LaisPrimaryButton variant="ghost" @click="emit('clear')">
          {{ t('SUPPORT_TICKETS.FILTERS.CLEAR') }}
        </LaisPrimaryButton>
        <LaisPrimaryButton @click="emit('submit')">
          {{ t('SUPPORT_TICKETS.FILTERS.APPLY') }}
        </LaisPrimaryButton>
      </div>
    </template>
  </LaisDrawer>
</template>
